import React, { useState } from 'react';
import ClientList from './ClientList';
import ClientForm from './ClientForm';
import { Client } from '../../../types/saas';

const ClientManager: React.FC = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingClient, setEditingClient] = useState<Client | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleAdd = () => {
    setEditingClient(null);
    setShowForm(true);
  };

  const handleEdit = (client: Client) => {
    setEditingClient(client);
    setShowForm(true);
  };

  const handleClose = () => {
    setShowForm(false);
    setEditingClient(null);
  };

  const handleSave = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div>
      <ClientList
        onEdit={handleEdit}
        onAdd={handleAdd}
        refreshTrigger={refreshTrigger}
      />
      
      {showForm && (
        <ClientForm
          client={editingClient}
          onClose={handleClose}
          onSave={handleSave}
        />
      )}
    </div>
  );
};

export default ClientManager;
